import {
  Modal,
  Row,
  Col,
  Typography,
  Card,
  Divider,
  Form,
  Input,
  Button,
  Space,
} from "antd";
import { useEffect } from "react";
import { createFromIconfontCN } from "@ant-design/icons";

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js",
});
const { Title, Text } = Typography;
export default function ContinueModal({
  showContinue,
  handleContinue,
  handleCloseModal,
  collectionDetails,
  data,
  allProducts,
  setCollectionStatus,
  flags,
}) {
  const [form] = Form.useForm();
  console.log(allProducts);
  useEffect(() => {
    if (collectionDetails) {
      form.setFieldsValue({
        buyer_name: collectionDetails?.buyer_name,
        collection_name: collectionDetails?.collection_name,
        email_ids: collectionDetails?.email_ids[0],
      });
    }
  }, [form, collectionDetails]);

  const onFinish = (values) => {
    console.log("Success:", values);
    handleContinue(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };


  return (
    <Modal
      visible={showContinue}
      onOk={() => onFinish()}
      onCancel={() => handleCloseModal()}
      destroyOnClose={true}
      footer={null}
      width={"75%"}
      bodyStyle={{ padding: "2.5rem" }}
      centered
    >
      <Form
        name="collection-details"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={24}>
            <Title level={2} style={{ fontFamily: "Gilroy", margin: 0 }}>
              {collectionDetails?.collection_name}
            </Title>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {data &&
              data.map((item, index) => (
                <Text
                  key={index}
                  style={{ marginRight: 5 }}
                  type="secondary"
                >{`${item?.name} (${item?.values.length ? item?.values.length : 0
                  })`}</Text>
              ))}
          </Col>
        </Row>
        <Row style={{ marginTop: "1.8rem" }}>
          <Col span={11}>
            <Row>
              <Title style={{ fontSize: 18, margin: 0 }}>
                Preview of the product
              </Title>
            </Row>
            <Row>
              <Text type="secondary">
                The buyer will see {flags?.showPrice ? "Price, " : ""}
                {flags?.showMoq ? "MOQ, " : ""}
                {flags?.showSamplingTime ? "Sampling lead time, " : ""}
                {flags?.showLeadTime ? "Production lead time, " : ""} Product ID
              </Text>
            </Row>

            <Row style={{ marginTop: "2rem" }}>
              {allProducts && allProducts?.length > 0 ? (
                <Card
                  key={allProducts[0]?.id}
                  className="product-card"
                  cover={
                    <img
                      alt="product name"
                      src={
                        allProducts &&
                          allProducts?.length > 0 &&
                          allProducts[0].product_images[0]
                          ? `${process.env.REACT_APP_DIRECTUS}assets/${allProducts[0]?.product_images[0]?.directus_files_id}?fit=cover&width=284&height=182&quality=100`
                          : "https://via.placeholder.com/283x184.png"
                      }
                    />
                  }
                >
                  <Row>
                    <Text className="product-id" type="secondary">
                      ID :{" "}
                      {allProducts[0]?.product_id
                        ? allProducts[0]?.product_id
                        : "No product id"}
                    </Text>
                  </Row>
                  {flags?.showPrice && allProducts[0]?.price && (
                    <Row align="bottom">
                      <Space>
                        <Title
                          level={4}
                          style={{ fontFamily: "Gilroy", margin: 0 }}
                        >
                          {allProducts[0]?.price
                            ? allProducts[0].currency +
                            " " +
                            allProducts[0]?.price
                            : ""}
                        </Title>
                        <Text type="secondary">
                          {allProducts[0]?.quantity
                            ? allProducts[0].quantity
                            : ""}
                        </Text>
                      </Space>
                    </Row>
                  )}

                  {flags?.showMoq && allProducts[0]?.moq ? (
                    <Row>
                      <Text level={1} className="product-id" type="secondary">
                        <IconFont type="icon-tuichu" /> MOQ :{" "}
                        {allProducts[0]?.moq}
                      </Text>
                    </Row>
                  ) : (
                    ""
                  )}

                  {flags?.showSamplingTime &&
                    allProducts[0]?.sampling_lead_time ? (
                    <Row>
                      <Text level={1} className="product-id" type="secondary">
                        Sampling Time : {allProducts[0]?.sampling_lead_time}
                      </Text>
                    </Row>
                  ) : (
                    ""
                  )}

                  {flags?.showSamplingTime &&
                    allProducts[0]?.production_lead_time ? (
                    <Row>
                      <Text level={1} className="product-id" type="secondary">
                        Lead Time : {allProducts[0]?.production_lead_time}
                      </Text>
                    </Row>
                  ) : (
                    ""
                  )}
                </Card>
              ) : null}
            </Row>
          </Col>
          <Col span={1}>
            {" "}
            <Divider
              type="vertical"
              style={{ height: "100%" }}
              plain
            ></Divider>{" "}
          </Col>
          <Col span={12}>
            <Row>
              <Title style={{ fontSize: 18, margin: 0 }}>Buyer Details</Title>
            </Row>
            <Row>
              <Text type="secondary">
                Review the details , you can update the details if needed
              </Text>
            </Row>
            <Row style={{ marginTop: "2rem" }}>
              <Col span={24}>
                <Form.Item
                  style={{ marginBottom: 40 }}
                  label="Company name"
                  name="buyer_name"
                  rules={[{ required: true, message: "Enter company name" }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: 40 }}
                  label="Catalogue name"
                  name="collection_name"
                  rules={[{ required: true, message: "Enter Catalogue name" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Email ID"
                  name="email_ids"
                  style={{ marginBottom: 40 }}
                  rules={[{ required: true, type: "email", message: "Enter valid email" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row justify="end" style={{ marginTop: "2rem" }}>

          <Col span={4}>
            {" "}
            <Button
              onClick={() => setCollectionStatus("published")}
              style={{ width: "100%" }}
              htmlType="submit"
              type="primary"
            >
              Generate catalogue
            </Button>{" "}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
